import script from "./HomePageRenderer.vue?vue&type=script&setup=true&lang=js"
export * from "./HomePageRenderer.vue?vue&type=script&setup=true&lang=js"

import "./HomePageRenderer.vue?vue&type=style&index=0&id=b69d8b08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b69d8b08"]])

export default __exports__